import React from 'react';
import { TabListItem } from './TabListStyles';

export interface IProps {
  label: string;
  name: string;
  onClick: (name: string) => void;
  isActive: boolean;
}
export const Tab: React.FC<IProps> = (props: IProps) => {
  const { name, onClick } = props;

  const onClickHandler = () => {
    onClick(name);
  };

  return (
    <TabListItem className={`tab-list-item ${props.isActive ? 'active' : ''}`} onClick={onClickHandler} data-test={`${name}-tab-item`}>
      {props.label}
    </TabListItem>
  );
};
